<script setup>
// Program cards (Academy). SplitHeaderBlock (heading left) + a single-column,
// full-width stack of colour-coded ContentCard (variant="program" — Feature
// tonal illustration splash left/right, title, description, circular arrow
// CTA chip; jk-21 follow-up, 2026-08-07 — replaces the old "plain" variant's
// icon + old public/illustrations/colour-combos splash + inert text CTA).
// ContentCard renders its own whole-card link now (its `to` prop), so no
// external wrapper is needed any more — matches the arrow/splash variants'
// own self-contained link pattern. Migrated from the bespoke Programs.vue
// view (jk-6); wraps the shared card so content pages can render it from a
// `programCards` block.
import SplitHeaderBlock from '@/components/SplitHeaderBlock.vue'
import ContentCard from '@/components/ContentCard.vue'

defineProps({
  block: { type: Object, required: true },   // { heading, items: [{ title, description, cta, colour, to? }] }
})

// One Feature tonal variation per card, cycling A-D for visual variety — no
// specific meaning attached beyond "not all identical"; fine to change by
// eye. Fixed (not random): every program is real, permanent content, not a
// per-visit pick, so there's no reason to add the seeding random would need.
const ILLO_VARIATIONS = ['A', 'B', 'C', 'D']
</script>

<template>
  <SplitHeaderBlock :heading="block.heading" class="program-cards">
    <div class="grid">
      <ContentCard
        v-for="(program, i) in block.items"
        :key="program.title"
        variant="program"
        :to="program.to"
        :colour="program.colour || 'pink'"
        :title="program.title"
        :body="program.description"
        :cta="program.cta || 'Learn more'"
        :illoVariation="ILLO_VARIATIONS[i % ILLO_VARIATIONS.length]"
        :image-position="i % 2 === 0 ? 'left' : 'right'"
      />
    </div>
  </SplitHeaderBlock>
</template>

<style lang="scss" scoped>
.program-cards {
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: $space-6;
  }
}
</style>
